/**
 * @desc create
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.StockAdjustmentCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustment/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
